var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.029,
    height: 11.029,
    viewBox: "0 0 11.029 11.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q12x8jqyja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 229",
    d: "M0 0h11.029v-11.029H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1482",
    transform: "translate(0 11.029)",
    style: {
      clipPath: "url(#q12x8jqyja)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1481"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 228",
    d: "M0 0h3.741v3.741M3.464.274l-4.5 4.5M-3.893 0h-.579a1.6 1.6 0 0 0-1.6 1.6v6.61a1.6 1.6 0 0 0 1.6 1.6h6.611a1.6 1.6 0 0 0 1.6-1.6v-.859",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.2px",
      fill: "none"
    },
    transform: "translate(6.681 -10.422)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.0ed99b9076f3582f3c10b9f4bc140151.svg";
export { ForwardRef as ReactComponent };